import { hslTripletToRgb } from '../../utils/theme-color.ts';

/** Reads the agent's voice palette and bounded visual tuning from its active theme. */
export function readWaveformTheme(style: Pick<CSSStyleDeclaration, 'getPropertyValue'>) {
  const color = (name: string) => hslTripletToRgb(style.getPropertyValue(name).trim());
  const listening = color('--voice-wave-listening') ?? { r: 181, g: 229, b: 127 };
  const speaking = color('--voice-wave-speaking') ?? { r: 56, g: 98, b: 204 };
  const tuning = (name: string, fallback: number, min: number, max: number) => {
    const raw = style.getPropertyValue(name).trim();
    const value = raw ? Number(raw) : NaN;
    return Number.isFinite(value) ? Math.min(max, Math.max(min, value)) : fallback;
  };
  return {
    listening,
    speaking,
    frequency: tuning('--voice-wave-frequency', 0.02, 0.01, 0.04),
    speed: tuning('--voice-wave-speed', 1, 0.5, 1.5),
    width: tuning('--voice-wave-width', 4.5, 2, 6),
  };
}
